import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { AiFeatureInterface } from './ai-feature.interface';

@Component({
  selector: 'app-ai-feature-card',
  standalone: true,
  imports: [CommonModule, MatIconModule],
  template: `
    <div class="ai-feature-card">
      <div class="icon-wrapper">
        <mat-icon class="feature-icon">{{feature.icon}}</mat-icon>
        <div class="glow-effect"></div>
      </div>
      <div class="content">
        <h3>{{feature.title}}</h3>
        <p>{{feature.description}}</p>
      </div>
      <div class="rating">
        <span class="star" *ngFor="let star of [1,2,3,4,5]">★</span>
      </div>
    </div>
  `,
  styles: [`
    .ai-feature-card {
      background: rgba(255, 255, 255, 0.05);
      border-radius: 16px;
      padding: 2rem;
      text-align: center;
      position: relative;
      backdrop-filter: blur(10px);
      border: 1px solid rgba(255, 255, 255, 0.1);
      transition: transform 0.3s ease;
      color: white;
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
    }

    .ai-feature-card:hover {
      transform: translateY(-5px);
    }

    .icon-wrapper {
      position: relative;
      width: 80px;
      height: 80px;
      margin: 0 auto 1.5rem;
    }

    .feature-icon {
      position: relative;
      z-index: 2;
      font-size: 40px;
      width: 40px;
      height: 40px;
      color: white;
      animation: pulse 2s infinite;
    }

    .glow-effect {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 100%;
      height: 100%;
      background: radial-gradient(circle, rgba(255, 255, 255, 0.2) 0%, rgba(255, 255, 255, 0) 70%);
      border-radius: 50%;
      animation: glow 2s infinite;
    }

    .content {
      flex: 1;
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      margin-bottom: 1.5rem;
    }

    h3 {
      color: white;
      margin-bottom: 1rem;
      font-size: 1.25rem;
    }

    p {
      color: rgba(255, 255, 255, 0.8);
      line-height: 1.6;
      margin: 0;
    }

    .rating {
      display: flex;
      justify-content: center;
      gap: 4px;
    }

    .star {
      color: #ffd700;
      font-size: 1.2rem;
    }

    @keyframes pulse {
      0% { transform: scale(1); }
      50% { transform: scale(1.1); }
      100% { transform: scale(1); }
    }

    @keyframes glow {
      0% { opacity: 0.5; }
      50% { opacity: 1; }
      100% { opacity: 0.5; }
    }
  `]
})
export class AiFeatureCardComponent {
  @Input() feature!: AiFeatureInterface;
}